"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateArray = exports.ArrayObserver = exports.ObservableArray$unshift = exports.ObservableArray$splice = exports.ObservableArray$sort = exports.ObservableArray$shift = exports.ObservableArray$reverse = exports.ObservableArray$push = exports.ObservableArray$pop = exports.ObservableArray$fill = exports.ObservableArray$copyWithin = exports.ObservableArray$batchUpdate = exports.ObservableArray$overrideNativeMethods = exports.ObservableArrayImplementation = exports.ArrayChangeType = exports.ObservableArray = void 0;
var events_1 = require("./events");
var helpers_1 = require("./helpers");
// eslint-disable-next-line import/export, no-redeclare, @typescript-eslint/no-unused-vars
var ObservableArray = /** @class */ (function () {
    function ObservableArray() {
    }
    /**
     * Returns a value indicating whether the given array is observable
     * @param array The array to check for observability
     */
    ObservableArray.isObservableArray = function (array) {
        return helpers_1.hasOwnProperty(array, "__aob__") && array.__aob__.constructor === ArrayObserver;
    };
    /**
     * Makes the given array observable, if not already
     * @param array The array to make observable
     */
    ObservableArray.ensureObservable = function (array) {
        // Check to see if the array is already an observable list
        if (ObservableArray.isObservableArray(array)) {
            return array;
        }
        if (helpers_1.hasOwnProperty(array, "__aob__")) {
            // TODO: Warn about invalid '__aob__' property?
            return;
        }
        Object.defineProperty(array, "__aob__", {
            configurable: false,
            enumerable: false,
            value: new ArrayObserver(array),
            writable: false
        });
        Object.defineProperty(array, "changed", {
            configurable: false,
            enumerable: true,
            get: function () {
                return this.__aob__.changed;
            }
        });
        array["batchUpdate"] = ObservableArray$batchUpdate;
        ObservableArray$overrideNativeMethods.call(array);
        return array;
    };
    /**
     * Creates a new observable array
     * @param items The initial array items
     */
    ObservableArray.create = function (items) {
        if (items === void 0) { items = []; }
        var array;
        if (items instanceof ObservableArray)
            array = items;
        else
            array = new (ObservableArrayImplementation.bind.apply(ObservableArrayImplementation, __spreadArrays([void 0], items)))();
        ObservableArray.ensureObservable(array);
        return array;
    };
    return ObservableArray;
}());
exports.ObservableArray = ObservableArray;
var ArrayChangeType;
(function (ArrayChangeType) {
    ArrayChangeType[ArrayChangeType["add"] = 1] = "add";
    ArrayChangeType[ArrayChangeType["remove"] = 2] = "remove";
    ArrayChangeType[ArrayChangeType["replace"] = 4] = "replace";
    ArrayChangeType[ArrayChangeType["reorder"] = 8] = "reorder";
})(ArrayChangeType = exports.ArrayChangeType || (exports.ArrayChangeType = {}));
var ObservableArrayImplementation = /** @class */ (function (_super) {
    __extends(ObservableArrayImplementation, _super);
    /**
     * Creates a new observable array
     * @param items The array of initial items
     */
    function ObservableArrayImplementation() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var _this = _super.apply(this, items) || this;
        Object.defineProperty(_this, "__aob__", {
            configurable: false,
            enumerable: false,
            value: new ArrayObserver(_this),
            writable: false
        });
        Object.defineProperty(_this, "changed", {
            get: function () {
                return this.__aob__.changed;
            }
        });
        if (_this.constructor !== ObservableArrayImplementation) {
            _this["batchUpdate"] = (function (fn) { ObservableArray$batchUpdate.call(this, fn); });
            ObservableArray$overrideNativeMethods.call(_this);
        }
        return _this;
    }
    Object.defineProperty(ObservableArrayImplementation.prototype, "changed", {
        /** Expose the changed event */
        get: function () {
            return this.__aob__.changed;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Begin queueing changes to the array, make changes in the given callback function, then stop queueing and raise events
     */
    ObservableArrayImplementation.prototype.batchUpdate = function (fn, additionalArgs) {
        if (additionalArgs === void 0) { additionalArgs = null; }
        ObservableArray$batchUpdate.call(this, fn, additionalArgs);
    };
    /**
     * The copyWithin() method shallow copies part of an array to another location in the same array and returns it, without modifying its size.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/copyWithin
     * @param target Zero based index at which to copy the sequence to. If negative, target will be counted from the end. If target is at or greater than arr.length, nothing will be copied. If target is positioned after start, the copied sequence will be trimmed to fit arr.length.
     * @param start Zero based index at which to start copying elements from. If negative, start will be counted from the end. If start is omitted, copyWithin will copy from the start (defaults to 0).
     * @param end Zero based index at which to end copying elements from. copyWithin copies up to but not including end. If negative, end will be counted from the end. If end is omitted, copyWithin will copy until the end (default to arr.length).
     * @returns The modified array.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ObservableArrayImplementation.prototype.copyWithin = function (target, start, end) {
        return ObservableArray$copyWithin.apply(this, arguments);
    };
    /**
     * The fill() method fills all the elements of an array from a start index to an end index with a static value. The end index is not included.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
     * @param value Value to fill an array.
     * @param start Start index, defaults to 0.
     * @param end End index, defaults to this.length.
     * @returns The modified array.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ObservableArrayImplementation.prototype.fill = function (value, start, end) {
        return ObservableArray$fill.apply(this, arguments);
    };
    /**
     * The pop() method removes the last element from an array and returns that element. This method changes the length of the array.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop
     * @returns The removed element from the array; undefined if the array is empty.
     */
    ObservableArrayImplementation.prototype.pop = function () {
        return ObservableArray$pop.apply(this, arguments);
    };
    /**
     * The push() method adds one or more elements to the end of an array and returns the new length of the array.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/push
     * @param items The elements to add to the end of the array.
     * @returns The new length property of the object upon which the method was called.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ObservableArrayImplementation.prototype.push = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        return ObservableArray$push.apply(this, arguments);
    };
    /**
     * The reverse() method reverses an array in place. The first array element becomes the last, and the last array element becomes the first.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reverse
     * @returns The reversed array.
     */
    ObservableArrayImplementation.prototype.reverse = function () {
        return ObservableArray$reverse.apply(this, arguments);
    };
    /**
     * The shift() method removes the first element from an array and returns that removed element. This method changes the length of the array.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/shift
     * @returns The removed element from the array; undefined if the array is empty.
     */
    ObservableArrayImplementation.prototype.shift = function () {
        return ObservableArray$shift.apply(this, arguments);
    };
    /**
     * The sort() method sorts the elements of an array in place and returns the array. Javascript sort algorithm on V8 is now stable. The default sort order is according to string Unicode code points.
     * The time and space complexity of the sort cannot be guaranteed as it is implementation dependent.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
     * @param compareFunction Specifies a function that defines the sort order. If omitted, the array is sorted according to each character's Unicode code point value, according to the string conversion of each element.
     * @returns The sorted array. Note that the array is sorted in place, and no copy is made.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ObservableArrayImplementation.prototype.sort = function (compareFunction) {
        return ObservableArray$sort.apply(this, arguments);
    };
    /**
     * The splice() method changes the contents of an array by removing existing elements and/or adding new elements.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice
     * @param start  Index at which to start changing the array (with origin 0). If greater than the length of the array, actual starting index will be set to the length of the array. If negative, will begin that many elements from the end of the array (with origin -1) and will be set to 0 if absolute value is greater than the length of the array.
     * @param deleteCount An integer indicating the number of old array elements to remove. If deleteCount is omitted, or if its value is larger than array.length - start (that is, if it is greater than the number of elements left in the array, starting at start), then all of the elements from start through the end of the array will be deleted. If deleteCount is 0 or negative, no elements are removed. In this case, you should specify at least one new element (see below).
     * @param items The elements to add to the array, beginning at the start index. If you don't specify any elements, splice() will only remove elements from the array.
     * @returns An array containing the deleted elements. If only one element is removed, an array of one element is returned. If no elements are removed, an empty array is returned.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ObservableArrayImplementation.prototype.splice = function (start, deleteCount) {
        var items = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            items[_i - 2] = arguments[_i];
        }
        return ObservableArray$splice.apply(this, arguments);
    };
    /**
     * The unshift() method adds one or more elements to the beginning of an array and returns the new length of the array.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/unshift
     * @param items The elements to add to the front of the array.
     * @returns The new length property of the object upon which the method was called.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ObservableArrayImplementation.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return ObservableArray$unshift.apply(this, arguments);
    };
    return ObservableArrayImplementation;
}(Array));
exports.ObservableArrayImplementation = ObservableArrayImplementation;
/**
 * Override's native Array methods that manipulate the array
 * @param array The array to extend
 */
function ObservableArray$overrideNativeMethods() {
    this["copyWithin"] = ObservableArray$copyWithin;
    this["fill"] = ObservableArray$fill;
    this["pop"] = ObservableArray$pop;
    this["push"] = ObservableArray$push;
    this["reverse"] = ObservableArray$reverse;
    this["shift"] = ObservableArray$shift;
    this["sort"] = ObservableArray$sort;
    this["splice"] = ObservableArray$splice;
    this["unshift"] = ObservableArray$unshift;
}
exports.ObservableArray$overrideNativeMethods = ObservableArray$overrideNativeMethods;
/**
 * Begin queueing changes to the array, make changes in the given callback function, then stop queueing and raise events
 */
function ObservableArray$batchUpdate(fn, additionalArgs) {
    if (additionalArgs === void 0) { additionalArgs = null; }
    this.__aob__.startQueueingChanges();
    try {
        fn(this);
        this.__aob__.stopQueueingChanges(true, additionalArgs);
    }
    finally {
        if (this.__aob__._isQueuingChanges) {
            this.__aob__.stopQueueingChanges(false, additionalArgs);
        }
    }
}
exports.ObservableArray$batchUpdate = ObservableArray$batchUpdate;
/**
 * The copyWithin() method shallow copies part of an array to another location in the same array and returns it, without modifying its size.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/copyWithin
 * @param array The observable array
 * @param target Zero based index at which to copy the sequence to. If negative, target will be counted from the end. If target is at or greater than arr.length, nothing will be copied. If target is positioned after start, the copied sequence will be trimmed to fit arr.length.
 * @param start Zero based index at which to start copying elements from. If negative, start will be counted from the end. If start is omitted, copyWithin will copy from the start (defaults to 0).
 * @param end Zero based index at which to end copying elements from. copyWithin copies up to but not including end. If negative, end will be counted from the end. If end is omitted, copyWithin will copy until the end (default to arr.length).
 */
function ObservableArray$copyWithin(target, start, end) {
    Array.prototype.copyWithin.apply(this, arguments);
    // TODO: Warn about non-observable manipulation of observable array?
    this.__aob__.raiseEvents({ type: ArrayChangeType.replace, startIndex: start, endIndex: end });
    return this;
}
exports.ObservableArray$copyWithin = ObservableArray$copyWithin;
/**
 * The fill() method fills all the elements of an array from a start index to an end index with a static value. The end index is not included.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
 * @param array The observable array
 * @param value Value to fill an array.
 * @param start Start index, defaults to 0.
 * @param end End index, defaults to this.length.
 */
function ObservableArray$fill(value, start, end) {
    Array.prototype.fill.apply(this, arguments);
    // TODO: Warn about non-observable manipulation of observable array?
    this.__aob__.raiseEvents({ type: ArrayChangeType.replace, startIndex: start, endIndex: end });
    return this;
}
exports.ObservableArray$fill = ObservableArray$fill;
/**
 * The pop() method removes the last element from an array and returns that element. This method changes the length of the array.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop
 * @param array The observable array
 * @returns The removed element from the array; undefined if the array is empty.
 */
function ObservableArray$pop() {
    var originalLength = this.length;
    var removed = Array.prototype.pop.apply(this, arguments);
    if (this.length !== originalLength) {
        var removedIndex = originalLength - 1;
        this.__aob__.raiseEvents({ type: ArrayChangeType.remove, startIndex: removedIndex, endIndex: removedIndex, items: [removed] });
    }
    return removed;
}
exports.ObservableArray$pop = ObservableArray$pop;
/**
 * The push() method adds one or more elements to the end of an array and returns the new length of the array.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/push
 * @param array The observable array
 * @param items The elements to add to the end of the array.
 * @returns The new length property of the object upon which the method was called.
 */
function ObservableArray$push() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    // BUG: Babel's handling of rest arguments seems to be thrown off by 1 (due to the "this" argument?) - cognitoforms/model.js:#5
    items = Array.prototype.slice.call(arguments);
    var originalLength = this.length;
    var newLength = Array.prototype.push.apply(this, arguments);
    if (newLength > 0) {
        this.__aob__.raiseEvents({ type: ArrayChangeType.add, startIndex: originalLength, endIndex: originalLength + (newLength - originalLength) - 1, items: items });
    }
    return newLength;
}
exports.ObservableArray$push = ObservableArray$push;
/**
 * The reverse() method reverses an array in place. The first array element becomes the last, and the last array element becomes the first.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reverse
 * @param array The observable array
 * @returns The reversed array.
 */
function ObservableArray$reverse() {
    Array.prototype.reverse.apply(this, arguments);
    // TODO: Warn about non-observable manipulation of observable array?
    this.__aob__.raiseEvents({ type: ArrayChangeType.reorder, startIndex: 0, endIndex: this.length - 1 });
    return this;
}
exports.ObservableArray$reverse = ObservableArray$reverse;
/**
 * The shift() method removes the first element from an array and returns that removed element. This method changes the length of the array.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/shift
 * @param array The observable array
 * @returns The removed element from the array; undefined if the array is empty.
 */
function ObservableArray$shift() {
    var originalLength = this.length;
    var removed = Array.prototype.shift.apply(this, arguments);
    if (this.length !== originalLength) {
        this.__aob__.raiseEvents({ type: ArrayChangeType.remove, startIndex: 0, endIndex: 0, items: [removed] });
    }
    return removed;
}
exports.ObservableArray$shift = ObservableArray$shift;
/**
 * The sort() method sorts the elements of an array in place and returns the array. Javascript sort algorithm on V8 is now stable. The default sort order is according to string Unicode code points.
 * The time and space complexity of the sort cannot be guaranteed as it is implementation dependent.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
 * @param array The observable array
 * @param compareFunction Specifies a function that defines the sort order. If omitted, the array is sorted according to each character's Unicode code point value, according to the string conversion of each element.
 * @returns The sorted array. Note that the array is sorted in place, and no copy is made.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ObservableArray$sort(compareFunction) {
    Array.prototype.sort.apply(this, arguments);
    // TODO: Warn about non-observable manipulation of observable array?
    this.__aob__.raiseEvents({ type: ArrayChangeType.reorder, startIndex: 0, endIndex: this.length - 1 });
    return this;
}
exports.ObservableArray$sort = ObservableArray$sort;
/**
 * The splice() method changes the contents of an array by removing existing elements and/or adding new elements.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice
 * @param array The observable array
 * @param start  Index at which to start changing the array (with origin 0). If greater than the length of the array, actual starting index will be set to the length of the array. If negative, will begin that many elements from the end of the array (with origin -1) and will be set to 0 if absolute value is greater than the length of the array.
 * @param deleteCount An integer indicating the number of old array elements to remove. If deleteCount is omitted, or if its value is larger than array.length - start (that is, if it is greater than the number of elements left in the array, starting at start), then all of the elements from start through the end of the array will be deleted. If deleteCount is 0 or negative, no elements are removed. In this case, you should specify at least one new element (see below).
 * @param items The elements to add to the array, beginning at the start index. If you don't specify any elements, splice() will only remove elements from the array.
 * @returns An array containing the deleted elements. If only one element is removed, an array of one element is returned. If no elements are removed, an empty array is returned.
 */
function ObservableArray$splice(start, deleteCount) {
    var items = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        items[_i - 2] = arguments[_i];
    }
    // BUG: Babel's handling of rest arguments seems to be thrown off by 1 (due to the "this" argument?) - cognitoforms/model.js:#5
    items = Array.prototype.slice.call(arguments, 2);
    var removed = Array.prototype.splice.apply(this, arguments);
    if (removed.length > 0 || items.length > 0) {
        var changeEvents = [];
        if (removed.length > 0) {
            changeEvents.push({ type: ArrayChangeType.remove, startIndex: start, endIndex: start + removed.length - 1, items: removed });
        }
        if (items.length > 0) {
            changeEvents.push({ type: ArrayChangeType.add, startIndex: start, endIndex: start + items.length - 1, items: items });
        }
        this.__aob__.raiseEvents(changeEvents);
    }
    return removed;
}
exports.ObservableArray$splice = ObservableArray$splice;
/**
 * The unshift() method adds one or more elements to the beginning of an array and returns the new length of the array.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/unshift
 * @param array The observable array
 * @param items The elements to add to the front of the array.
 * @returns The new length property of the object upon which the method was called.
 */
function ObservableArray$unshift() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    // BUG: Babel's handling of rest arguments seems to be thrown off by 1 (due to the "this" argument?) - cognitoforms/model.js:#5
    items = Array.prototype.slice.call(arguments);
    var originalLength = this.length;
    var newLength = Array.prototype.unshift.apply(this, arguments);
    if (newLength !== originalLength) {
        this.__aob__.raiseEvents({ type: ArrayChangeType.add, startIndex: 0, endIndex: items.length - 1, items: items });
    }
    return newLength;
}
exports.ObservableArray$unshift = ObservableArray$unshift;
var ArrayObserver = /** @class */ (function () {
    function ArrayObserver(array) {
        this.array = array;
        this.changed = new events_1.Event();
        this._isQueuingChanges = false;
    }
    ArrayObserver.prototype.raiseEvents = function (changes, additionalArgs) {
        if (this._isQueuingChanges) {
            if (!this._queuedChanges) {
                this._queuedChanges = [];
            }
            if (Array.isArray(changes)) {
                Array.prototype.push.apply(this._queuedChanges, changes);
            }
            else {
                this._queuedChanges.push(changes);
            }
        }
        else if (Array.isArray(changes)) {
            if (changes.length)
                this.changed.publish(this.array, { changes: changes, additionalArgs: additionalArgs });
        }
        else {
            this.changed.publish(this.array, { changes: [changes], additionalArgs: additionalArgs });
        }
    };
    ArrayObserver.prototype.startQueueingChanges = function () {
        this._isQueuingChanges = true;
        if (!this._queuedChanges) {
            this._queuedChanges = [];
        }
    };
    ArrayObserver.prototype.stopQueueingChanges = function (raiseEvents, additionalArgs) {
        if (additionalArgs === void 0) { additionalArgs = null; }
        this._isQueuingChanges = false;
        if (raiseEvents) {
            this.raiseEvents(this._queuedChanges, additionalArgs);
            delete this._queuedChanges;
        }
    };
    return ArrayObserver;
}());
exports.ArrayObserver = ArrayObserver;
function callSplice(arr, index, removeCount, addItems) {
    if (removeCount || addItems.length > 0) {
        var addItemsArgs = [index, removeCount].concat(addItems);
        arr.splice.apply(arr, addItemsArgs);
    }
}
function updateArray(array, values) {
    var pointer = 0;
    var srcSeek = 0;
    var tgtSeek = 0;
    while (srcSeek < array.length) {
        if (array[srcSeek] === values[tgtSeek]) {
            if (pointer === srcSeek && pointer === tgtSeek) {
                // items match, so advance
                pointer = srcSeek = tgtSeek = pointer + 1;
            }
            else {
                // remove range from source and add range from target
                callSplice(array, pointer, srcSeek - pointer, values.slice(pointer, tgtSeek));
                // reset to index follow target seek location since arrays match up to that point
                pointer = srcSeek = tgtSeek = tgtSeek + 1;
            }
        }
        else if (tgtSeek >= values.length) {
            // reached the end of the target array, so advance the src pointer and test again
            tgtSeek = pointer;
            srcSeek += 1;
        }
        else {
            // advance to the next target item to test
            tgtSeek += 1;
        }
    }
    callSplice(array, pointer, srcSeek - pointer, values.slice(pointer, Math.max(tgtSeek, values.length)));
}
exports.updateArray = updateArray;
